import React from 'react'


class CustomToggle extends React.Component {
    constructor(props, context) {
      super(props, context);
  
      this.handleClick = this.handleClick.bind(this);
    }
  
    handleClick(e) {
      e.preventDefault();
      this.props.onClick(e);
    }
  
    render() {
      return (
        <a href="#" className={this.props.className} onClick={this.handleClick}>
          {this.props.children}
        </a>
      );
    }
  }


  export default CustomToggle